import { render, staticRenderFns } from "./AudioFormTreeNode.vue?vue&type=template&id=537ff7ea&scoped=true&"
import script from "./AudioFormTreeNode.vue?vue&type=script&lang=js&"
export * from "./AudioFormTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./AudioFormTreeNode.vue?vue&type=style&index=0&id=537ff7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ff7ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
